import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaXTwitter,
  FaWhatsapp,
} from "react-icons/fa6";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Row */}
        <div className="footer-main-row">
          <div className="footer-col">
            <p className="footer-title">Our Company</p>
            <ul>
              <li><Link to="/about-us">About Cake Restro</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/in-news">In News</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <p className="footer-title">Quick Links</p>
            <ul>
              <li><Link to="/sitemap">Sitemap</Link></li>
              <li><Link to="/reviews">Customer Reviews</Link></li>
              <li><Link to="/blogs">Blog</Link></li>
              <li><Link to="/wishes">Wishes</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <p className="footer-title">Policy & Security</p>
            <ul>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/cancellation-policy">Cancellation Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/payments-and-security">Payments & Security</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <p className="footer-title">Our Locations</p>
            <ul>
              <li><Link to="/cakes/mohali">Mohali</Link></li>
              <li><Link to="/cakes/zirakpur">Zirakpur</Link></li>
              <li><Link to="/cakes/panchkula">Panchkula</Link></li>
              <li><Link to="/cakes/chandigarh">Chandigarh</Link></li>

            </ul>
          </div>

          <div className="footer-col contact-col">
            <p className="footer-title">Connect with Us</p>
            <div className="footer-social-links">
              <a href="https://www.facebook.com/cakerestro/" className="social-icon"><FaFacebookF /></a>
              <a href="https://www.instagram.com/cakerestro/" className="social-icon"><FaInstagram /></a>
              <a href="https://www.youtube.com/@cakerestro" className="social-icon"><FaYoutube /></a>
              <a href="https://www.linkedin.com/in/cakerestro/" className="social-icon"><FaLinkedinIn /></a>
              <a href="https://x.com/cakerestro" className="social-icon"><FaXTwitter /></a>
              <a href="https://wa.me/9041314973" className="social-icon"><FaWhatsapp /></a>
            </div>
            <div className="footer-app-downloads">
              <p className="footer-subtitle">Download Our App</p>
              <div className="footer-app-buttons">
                <img loading="lazy" src="/google-play.png" alt="Google Play" />
                <img loading="lazy" src="/app-store.png" alt="App Store" />
              </div>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        {/* Legal & Copyright */}
        <div className="footer-legal">
          <p className="footer-copy">
            © 2022 – {new Date().getFullYear()} Cake Restro - All Rights Reserved
          </p>
          <div className="footer-legal-links">

            <span>Terms & Conditions</span>
            <span>Payments & Security</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
